import React, { memo } from "react";

const ExternalLinkIcon: React.FC = memo(() => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="10"
      height="10"
      viewBox="0 0 10 10"
      fill="none"
    >
      <path
        d="M1.11111 10C0.805556 10 0.543982 9.8912 0.326389 9.67361C0.108796 9.45602 0 9.19444 0 8.88889V1.11111C0 0.805556 0.108796 0.543982 0.326389 0.326389C0.543982 0.108796 0.805556 0 1.11111 0H4.44444C4.60185 0 4.7338 0.0532407 4.84028 0.159722C4.94676 0.266204 5 0.398148 5 0.555556C5 0.712963 4.94676 0.844907 4.84028 0.951389C4.7338 1.05787 4.60185 1.11111 4.44444 1.11111H1.11111V8.88889H8.88889V5.55556C8.88889 5.39815 8.94213 5.2662 9.04861 5.15972C9.15509 5.05324 9.28704 5 9.44444 5C9.60185 5 9.7338 5.05324 9.84028 5.15972C9.94676 5.2662 10 5.39815 10 5.55556V8.88889C10 9.19444 9.8912 9.45602 9.67361 9.67361C9.45602 9.8912 9.19444 10 8.88889 10H1.11111ZM8.88889 1.88889L4.11111 6.66667C4.00926 6.76852 3.87963 6.81945 3.72222 6.81945C3.56482 6.81945 3.43519 6.76852 3.33333 6.66667C3.23148 6.56482 3.18056 6.43519 3.18056 6.27778C3.18056 6.12037 3.23148 5.99074 3.33333 5.88889L8.11111 1.11111H6.66667C6.50926 1.11111 6.37732 1.05787 6.27083 0.951389C6.16435 0.844907 6.11111 0.712963 6.11111 0.555556C6.11111 0.398148 6.16435 0.266204 6.27083 0.159722C6.37732 0.0532407 6.50926 0 6.66667 0H10V3.33333C10 3.49074 9.94676 3.62269 9.84028 3.72917C9.7338 3.83565 9.60185 3.88889 9.44444 3.88889C9.28704 3.88889 9.15509 3.83565 9.04861 3.72917C8.94213 3.62269 8.88889 3.49074 8.88889 3.33333V1.88889Z"
        fill="currentColor"
      />
    </svg>
  );
});

export { ExternalLinkIcon };
